import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { getDatabase } from "firebase/database"; 

const firebaseConfig = {
  apiKey: "AIzaSyAALNUnJYknJyg6OQVBH6y0Xoq4_GrlhoA",
  authDomain: "estbn-systems.firebaseapp.com",
  projectId: "estbn-systems",
  storageBucket: "estbn-systems.firebasestorage.app",
  messagingSenderId: "336285762910",
  appId: "1:336285762910:web:4a4d80628275f95fa4bbcf",
  databaseURL: "https://estbn-systems-default-rtdb.firebaseio.com", 
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);
export const database = getDatabase(app); 